import React from 'react'
import ButtonAdminpanel from '@/components/ButtonAdminpanel';
import ConfirmPayment from '@/assets/images/svg/stepper/confirm-payment.svg';
import mailIcon from '@/assets/images/svg/stepper/mail-icon.svg';
import phoneIcon from '@/assets/images/svg/stepper/phone-icon.svg';
import BackButton from '@/components/stepper/backbutton';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { buildPath, getPrefix } from '@/utils/common';
import { privateRoutePaths } from '@/routes/private.route.config';
import thumbsUp from '@/assets/images/svg/stepper/thumbsUp-icon.svg';
import { useAuth } from '@/AuthProvider';

const ConfirmStep = (props) => {
  
  const { supplierMember, supplier_id } = props;

  const { user } = useAuth();

  const nav = useNavigate();

  return (
    <div className='confirm-step-wrape'>
         <div className='confirm-icon'>
          {supplierMember && supplierMember.step_3 && supplierMember.step_3.plan_name == "Trial" ? 
            <img src={thumbsUp} alt="confirm-payment" /> 
          : <img src={ConfirmPayment} alt="confirm-payment" />
          }
         </div>

         <div className='confirm-heading'>
          {supplierMember && supplierMember.step_3 && supplierMember.step_3.plan_name == "Trial" ?
            <h2>Thank you for choosing the Trial plan!</h2>
            :  <h2>Your { supplierMember && supplierMember.step_3 && supplierMember.step_3.plan_name } plan is Now Active!.</h2>
          } 
         </div>
         <div className='confirm-decs'>
          { supplierMember && supplierMember.step_3 && supplierMember.step_3.plan_name == "Trial" ? 
            <p>Complete your profile and upgrade plan to increase visibility, attract relevant buyer inquiries, and start building global business connections.</p>
          : <p>Complete your profile to increase visibility, attract relevant buyer inquiries, and start building global business connections.</p>
          }
         </div>
          <div className='confirm-plan-box card'>
            {
              supplierMember.step_3 && supplierMember.step_3.plan_name != "Trial" && <div className="card-body">
                {
                  supplierMember && supplierMember.step_1 &&<p>Validity: <span> { moment(supplierMember.step_1.plan_from_date).format('DD/MM/YYYY') } to { 
                    moment(supplierMember.step_1.plan_to_date).format('DD/MM/YYYY') }</span></p>
                } 
                {
                  supplierMember && supplierMember.step_3 && <p>Plan: <span>{ supplierMember.step_3.plan_name }</span></p>
                }
                
               </div>
            }
               
          </div>
           <div className='confirm-btn'>
                <ButtonAdminpanel className="mt-3" type="submit" 
                // onClick={() => nav(`/${getPrefix(user)}${buildPath(privateRoutePaths.PRE_KYC_DASHBOARD)}`)}>
                onClick={() => {
    // Generates the destination URL string
    const targetUrl = `/${getPrefix(user)}${buildPath(privateRoutePaths.PRE_KYC_DASHBOARD)}`;
    
    // Forces a full page reload and redirects the browser
    window.location.replace(targetUrl);
  }}  >
                    Go to Dashboard
                </ButtonAdminpanel>
                
                {
                  supplierMember && supplierMember.step_3 && supplierMember.step_3.plan_name == "Trial" && <ButtonAdminpanel className="mt-3 confirm-update-profile" type="submit"    onClick={props.onPrev} >
                    Upgrade Your Plan
                  </ButtonAdminpanel>
                }
                
                {
                  supplierMember && supplierMember.step_3 && supplierMember.step_3.plan_name != "Trial" && <ButtonAdminpanel className="mt-3 confirm-update-profile" type="submit"
                  onClick={() => nav(`/${getPrefix(user)}${buildPath(privateRoutePaths.UPDATE_COMPANY_PROFILE, { id: supplier_id })}`) }
                  >
                    Update Profile
                  </ButtonAdminpanel>
                }
                

            </div>

           <div className='confirm-contact border-top '>
                   <span>Need assistance? Contact our support team:</span>
                  <a href={`mailto:${process.env.REACT_APP_CONNECT_MAIL}`} className="contact-item">
                     <img src={mailIcon} alt="mail-iocn" />
                      {process.env.REACT_APP_CONNECT_MAIL}
                   </a>
                      <a href={`tel:${process.env.REACT_APP_CONNECT_WHATSAPP_NUMBER}`} className="contact-item">
                      <img src={phoneIcon} alt="phone-icon" />
                      {process.env.REACT_APP_CONNECT_WHATSAPP_NUMBER}
                   </a>
            </div>   

            {
              // supplierMember && supplierMember.step_3 && supplierMember.step_3.plan_name == "Trial" && <div className='profile-button border-top'>
              //     <BackButton className="mt-3" type="submit" onClick={props.onPrev} >
              //         Back
              //     </BackButton>
              //   </div>
            }
            
    </div>
  )
}

export default ConfirmStep
